import Axios from "axios";
import db from "../../database";
import openDrawer from "./openDrawer";
import useAuthStore from "../../stores/useAuthStore";
import useSessionStore from "../../stores/useSessionStore";

const TillCloseHCPrint = async (printReciptData, cashValues, x, cashToKeep) => {
  const tillData = useAuthStore.getState().tillData;
  const userData = useAuthStore.getState().userData;
  const printerURL = tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl;
  let printData = tillData.tillAccess.cwrTill.tillCloseTemplate.xmlcode2;
  let ordersData = await db.ordersData.toArray();
  ordersData = ordersData.filter((data) => data.tillStatus === "open");
  let paymentsData = await db.paymentsData.toArray();
  paymentsData = paymentsData.filter((data) => data.tillStatus === "open");
  let tillEvents = await db.tillEvents.toArray();
  tillEvents = tillEvents.filter((data) => data.tillStatus === "open");
  const pricePrecision = tillData?.tillAccess?.csBunit?.currencies?.[0]?.prcPrecision ?? 2;
  const tillSession = useSessionStore.getState().tillSession;
  const allOrders = tillSession?.tillSessionId
    ? await db.orders.where("tillSessionId").equals(tillSession.tillSessionId).toArray()
    : await db.orders.toArray();

  if (!printData) {
    return printData;
  }
  let countedAmountsData = "";
  let toDepositAmount = "";
  let differenceAmountsData = "";
  let differenceAmountsDataTotal = 0;
  let totalDeposistsAmount = 0;
  let totalWithDrawalsAmount = 0;
  let TotalcountedAmount = 0;
  let totalToDepositAmount = 0;
  let startingPaymentsAmount = "";
  let taxDetails = "";
  let taxReturnDetails = "";
  let withdrawalsAmount = "";
  let depositsAmount = "";
  let totalExpectedAmount = "";
  let expectedAmountsData = "";
  tillEvents[0]?.allPaymentsData?.map((data) => {
    return (
      (expectedAmountsData += `<line>
    <text align ="left" length="25" >${data.name}</text>
    <text align ="right" length="14" >${data.expectedAmount ? parseFloat(data.expectedAmount).toFixed(pricePrecision) : (0).toFixed(pricePrecision)}</text>
  </line>`),
      (totalExpectedAmount = tillEvents[0]?.allPaymentsData?.reduce((total, data) => total + parseFloat(data?.expectedAmount), 0).toFixed(pricePrecision)),
      (startingPaymentsAmount +=
        data.name === "Cash"
          ? `
        <line>
          <text align="left" length="25">${data.name}</text>
          <text align="right" length="14">${tillEvents[0]?.openingCash ? parseFloat(tillEvents[0]?.openingCash).toFixed(pricePrecision) : (0).toFixed(pricePrecision)}</text>
        </line>`
          : ""),
      (withdrawalsAmount += `
  <line>
    <text align ="left" length="25" >${data.name}</text>
    <text align="right" length="14">${
      data.name === "Cash"
        ? (
            parseFloat(data.paymentReturn) +
            (tillEvents[0]?.cashInOutData ? parseFloat(tillEvents[0]?.cashInOutData?.cashOut || 0) + parseFloat(tillEvents[0]?.cashInOutData?.pettyCashOut || 0) : 0)
          ).toFixed(pricePrecision)
        : parseFloat(data.paymentReturn).toFixed(pricePrecision)
    }
</text>

    </line>
  `),
      (totalWithDrawalsAmount = tillEvents[0]?.allPaymentsData?.reduce((total, data) => total + parseFloat(data.paymentReturn), 0) || 0),
      (depositsAmount += `
  <line>
    <text align ="left" length="25" >${data.name}</text>
    <text align="right" length="14">${
      data.name === "Cash"
        ? (
            parseFloat(data.cashSaleAmount || 0) +
            (tillEvents[0]?.cashInOutData ? parseFloat(tillEvents[0]?.cashInOutData?.cashIn || 0) + parseFloat(tillEvents[0]?.cashInOutData?.pettyCashIn || 0) : 0)
          ).toFixed(pricePrecision)
        : parseFloat(data?.saleAmount || 0).toFixed(pricePrecision)
    }</text>
  
    </line>
  `),
      (totalDeposistsAmount =
        tillEvents[0]?.allPaymentsData?.reduce((total, data) => {
          const amount = data.cashSaleAmount !== undefined && data.cashSaleAmount !== null ? data.cashSaleAmount : data?.saleAmount;
          return total + amount;
        }, 0) || 0),
      (countedAmountsData += `
  <line>
    <text align ="left" length="25" >${data.name}</text>
    <text align ="right" length="14" >${data?.amount ? parseFloat(data.amount).toFixed(pricePrecision) : (0).toFixed(pricePrecision)}</text>
  </line>
  `),
      (TotalcountedAmount = tillEvents[0]?.allPaymentsData?.reduce((total, data) => total + parseFloat(data.amount), 0).toFixed(pricePrecision)),
      (toDepositAmount += `
      <line>
        <text align ="left" length="25" >${data.name}</text>
        <text align="right" length="14">${
          data.name === "Cash"
            ? (parseFloat(data.amount || 0) - parseFloat(tillEvents[0]?.checkedValue).toFixed(pricePrecision)).toFixed(pricePrecision)
            : parseFloat(data.amount || 0).toFixed(pricePrecision)
        }</text>
      </line>
      `),
      (totalToDepositAmount = tillEvents[0]?.allPaymentsData?.reduce((total, data) => total + parseFloat(data.amount), 0).toFixed(pricePrecision)),
      (differenceAmountsData += `<line>
    <text align ="left" length="25" >${data.name}</text>
    <text align ="right" length="14" >${data.difference ? parseFloat(data.difference).toFixed(pricePrecision) : (0).toFixed(pricePrecision)}</text>
  </line>`),
      (differenceAmountsDataTotal = tillEvents[0]?.allPaymentsData?.reduce((total, data) => total + parseFloat(data.difference), 0).toFixed(pricePrecision))
    );
  });
  totalWithDrawalsAmount =
    (parseFloat(totalWithDrawalsAmount) || 0) + (parseFloat(tillEvents[0]?.cashInOutData?.cashOut || 0) + parseFloat(tillEvents[0]?.cashInOutData?.pettyCashOut || 0));

  totalDeposistsAmount =
    (parseFloat(totalDeposistsAmount) || 0) + (parseFloat(tillEvents[0]?.cashInOutData?.cashIn || 0) + parseFloat(tillEvents[0]?.cashInOutData?.pettyCashIn || 0));

  totalWithDrawalsAmount = parseFloat(totalWithDrawalsAmount).toFixed(pricePrecision);
  totalDeposistsAmount = parseFloat(totalDeposistsAmount).toFixed(pricePrecision);

  totalToDepositAmount = (parseFloat(totalToDepositAmount) - Number(parseFloat(tillEvents[0]?.checkedValue).toFixed(pricePrecision))).toFixed(pricePrecision);
  const groupedByVatPercentage = {};
  ordersData[0]?.salesTax?.forEach((vat) => {
    const vatPercentage = vat.taxRate;
    if (!groupedByVatPercentage[vatPercentage]) {
      groupedByVatPercentage[vatPercentage] = {
        vatPercentage: vatPercentage,
        totalVatAmount: 0,
      };
    }

    groupedByVatPercentage[vatPercentage].totalVatAmount += parseFloat(vat.taxAmt);
  });

  Object.values(groupedByVatPercentage).forEach((group) => {
    taxDetails += `
      <line>
        <text align="left" length="25">VAT ${group.vatPercentage}%</text>
        <text align="right" length="14">${group.totalVatAmount.toFixed(pricePrecision)}</text>
      </line>`;
  });
  const groupedReturnByVatPercentage = {};

  ordersData[0]?.returnTax?.forEach((vat) => {
    const vatPercentage = vat.taxRate;
    if (!groupedReturnByVatPercentage[vatPercentage]) {
      groupedReturnByVatPercentage[vatPercentage] = {
        vatPercentage: vatPercentage,
        totalVatAmount: 0,
      };
    }

    groupedReturnByVatPercentage[vatPercentage].totalVatAmount += parseFloat(vat.taxAmt);
  });

  Object.values(groupedReturnByVatPercentage).forEach((group) => {
    taxReturnDetails += `
      <line>
        <text align="left" length="25">VAT ${group.vatPercentage}%</text>
        <text align="right" length="14">${Math.abs(group.totalVatAmount).toFixed(pricePrecision)}</text>
      </line>`;
  });

  let toKeepAmount = `
  <line>
    <text align ="left" length="25" >Cash</text>
    <text align ="right" length="14" >${Number(parseFloat(tillEvents[0]?.checkedValue).toFixed(pricePrecision)).toFixed(pricePrecision)}</text>
  </line>`;
  printData = printData.replaceAll("@@status@@", `Closed`);
  printData = printData.replaceAll("@@storeName@@", `${tillData.tillAccess.csBunit.name}`);
  printData = printData.replaceAll("@@tillID@@", `${tillData.tillAccess.cwrTill.till}`);
  printData = printData.replaceAll("@@user@@", `${userData?.user}`);
  printData = printData.replaceAll("@@openingTime@@", `${printReciptData?.openingTime}`);
  printData = printData.replaceAll("@@closingTime@@", `${printReciptData?.closingTime}`);
  printData = printData.replaceAll("@@netSalesAmount@@", `${parseFloat(ordersData[0]?.netTotal).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@netReturnAmount@@", `${Math.abs(parseFloat(ordersData[0]?.netReturnTotal)).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@grossSalesAmount@@", `${parseFloat(ordersData[0]?.grossTotal).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@grossReturnAmount@@", `${Math.abs(parseFloat(ordersData[0]?.grossReturnTotal)).toFixed(pricePrecision)}`);
  // Exclude return orders (negative total) — a return order's payments carry a negative
  // refund entry (even when refunded via a different method than the original sale), and
  // including it here nets the sales side against the return, silently cancelling the
  // return back out of @@retailTransactions@@ below instead of adding to it.
  const localGrossTotal = allOrders
    .filter((o) => (Number(o?.total) || 0) > 0)
    .reduce((sum, o) => sum + (o.payments || []).reduce((pSum, p) => pSum + parseFloat(p.amount || 0), 0), 0);
  const localGrossReturnTotal = Math.abs(parseFloat(ordersData[0]?.grossReturnTotal || 0));
  // Net, not sum: ordersData[0].grossReturnTotal is stored negative, and both 25Q3.1.0 and
  // roadmap add that raw (negative) value here — i.e. Gross Sales minus the return magnitude.
  // localGrossReturnTotal above is abs()'d for display, so it must be subtracted here.
  printData = printData.replaceAll("@@retailTransactions@@", `${(localGrossTotal - localGrossReturnTotal).toFixed(pricePrecision)}`);
  printData = printData.replaceAll(
    "@@totalStartingAmount@@",
    `${tillEvents[0]?.openingCash ? parseFloat(tillEvents[0]?.openingCash).toFixed(pricePrecision) : (0).toFixed(pricePrecision)}`
  );
  printData = printData.replaceAll("@@totalDeposistsAmount@@", `${totalDeposistsAmount}`);
  printData = printData.replaceAll("@@countedAmount@@", `${countedAmountsData}`);
  printData = printData.replaceAll("@@totalCountedAmount@@", `${TotalcountedAmount ? TotalcountedAmount : (0).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@expectedAmount@@", `${expectedAmountsData}`);
  printData = printData.replaceAll("@@totalExpectedAmount@@", `${totalExpectedAmount ? totalExpectedAmount : (0).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@differenceAmount@@", `${differenceAmountsData}`);
  printData = printData.replaceAll("@@totalDifferenceAmount@@", `${differenceAmountsDataTotal ? differenceAmountsDataTotal : (0).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@totalToDepositAmount@@", `${totalToDepositAmount ? totalToDepositAmount : (0).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@totalWithDrawalsAmount@@", `${totalWithDrawalsAmount ? totalWithDrawalsAmount : (0).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@startingPaymentsAmount@@", `${startingPaymentsAmount}`);
  printData = printData.replaceAll("@@taxDetails@@", `${taxDetails}`);
  printData = printData.replaceAll("@@taxReturnDetails@@", `${taxReturnDetails}`);
  printData = printData.replaceAll("@@toKeepAmount@@", `${toKeepAmount}`);
  printData = printData.replaceAll("@@totalToKeepAmount@@", `${parseFloat(tillEvents[0]?.checkedValue).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@toDepositAmount@@", `${toDepositAmount ? toDepositAmount : (0).toFixed(pricePrecision)}`);
  printData = printData.replaceAll("@@withdrawalsAmount@@", `${withdrawalsAmount}`);
  printData = printData.replaceAll("@@depositsAmount@@", `${depositsAmount}`);

  Axios.post(`${printerURL}printer`, printData, {
    headers: {
      "Content-Type": "application/xml; charset=UTF-8",
      Accept: "application/xml",
    },
  })
    .then(() => {
      openDrawer();
    })
    .catch((response) => {
    });
};
export default TillCloseHCPrint;
